import styled from 'styled-components';

type ContainerProps = {
  background: string,
  width: string
};

export const SearchContainer = styled.div<ContainerProps>`
  display: flex;
  align-items: center;
  color: ${(props) => props.theme.colors.outlineActiveButton};
  position: relative;
  width: ${props => props.width};
  background-color: ${(props) => props.background};
  font-weight: 500;

  #search-icon {
    position: absolute;
    z-index: 1;
    margin-top: 8px;
    margin-left: 10px;
    color: #1e4883;
    width: 16px;
    height: 16px;
  }

  #search-input {
    border: 1px solid ${(props) => props.theme.colors.solidButton};
    background: ${props => props.theme.colors.background};
    height: 40px;
    width: 100%;
    color: #a6a6a6;
    font-size: 12px;
    font-family: Roboto, sans-serif;
    font-weight: 600;

    :focus::placeholder {
      color: #a6a6a6;
    }

    :hover {
      font-style: italic;
    }

    ::placeholder {
      color: ${(props) => props.theme.colors.textTitle};
      font-weight: 600;
    }   
  }
`;

export const Icon = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  svg{
    font-size: 20px;
    padding-left: 10px;
    color: ${(props) => props.theme.colors.textTitle};
  }
`;

export const Input = styled.input`
  background: #fff;
  border: 1px solid #004992;
  letter-spacing: 1px;
  padding-right: 50px;
  padding-left: 40px;    
  border-radius: 5px;
  height: 40px;
  font-size: 12px;    
  outline: none;
  width: 100%;
  box-sizing: border-box;

  ::placeholder {
    color: #004992;
  }
  &:hover {
    font-style: italic;
  }
`;